/**
 * JOMO Fizz'O'Foam Refill Bundle Builder
 * Scoped to [data-jrb-root] — one-time purchase only
 */
(function () {
  'use strict';

  function money(cents, moneyFormat) {
    var value = (Number(cents) / 100).toFixed(2);
    var whole = String(Math.round(Number(cents) / 100));
    if (!moneyFormat) {
      return Number(cents) % 100 === 0 ? '$' + whole : '$' + value;
    }
    try {
      if (moneyFormat.indexOf('{{amount_no_decimals}}') !== -1) {
        return moneyFormat.replace('{{amount_no_decimals}}', whole);
      }
      if (moneyFormat.indexOf('{{amount}}') !== -1) {
        var formatted = Number(cents) % 100 === 0 ? whole : value;
        return moneyFormat.replace('{{amount}}', formatted);
      }
      if (moneyFormat.indexOf('{{amount_with_comma_separator}}') !== -1) {
        return moneyFormat.replace('{{amount_with_comma_separator}}', value.replace('.', ','));
      }
    } catch (e) { /* fall through */ }
    return Number(cents) % 100 === 0 ? '$' + whole : '$' + value;
  }

  function parseRoot(root) {
    var raw = root.getAttribute('data-jrb-config');
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function initRoot(root) {
    if (root.getAttribute('data-jrb-ready') === 'true') return;
    var config = parseRoot(root);
    if (!config || !config.bundles || !config.bundles.length) return;
    root.setAttribute('data-jrb-ready', 'true');

    if (!config.scents) config.scents = [];
    var isBundleMode = config.mode === 'bundle';
    var isSimpleAtc = !!config.simpleAtc;
    var hasScents = !isBundleMode && !isSimpleAtc && config.scents.length > 0;

    var state = {
      selectedQty: Number(config.bundles[0].qty) || 2,
      selectedVariantId: config.bundles[0].variantId || null,
      scents: {},
      submitting: false
    };

    config.scents.forEach(function (s) {
      state.scents[s.key] = 0;
    });

    var els = {
      bundles: root.querySelectorAll('[data-jrb-bundle]'),
      scentRows: root.querySelectorAll('[data-jrb-scent]'),
      progress: root.querySelector('[data-jrb-progress]'),
      progressText: root.querySelector('[data-jrb-progress-text]'),
      progressFill: root.querySelector('[data-jrb-progress-fill]'),
      summary: root.querySelector('[data-jrb-summary]'),
      error: root.querySelector('[data-jrb-error]'),
      atc: root.querySelector('[data-jrb-atc]'),
      buyPrice: root.querySelector('[data-jrb-buy-price]'),
      chooseToggle: root.querySelector('[data-jrb-choose-toggle]'),
      chooseMenu: root.querySelector('[data-jrb-choose-menu]'),
      chooseLabel: root.querySelector('[data-jrb-choose-label]'),
      chooseOptions: root.querySelectorAll('[data-jrb-choose-all]')
    };

    function selectedTotal() {
      var total = 0;
      Object.keys(state.scents).forEach(function (key) {
        total += Number(state.scents[key]) || 0;
      });
      return total;
    }

    function currentBundle() {
      for (var i = 0; i < config.bundles.length; i++) {
        if (Number(config.bundles[i].qty) === Number(state.selectedQty)) {
          return config.bundles[i];
        }
      }
      return config.bundles[0];
    }

    function remaining() {
      return state.selectedQty - selectedTotal();
    }

    function isExact() {
      if (!state.selectedVariantId) return false;
      // No variants / no scent mix required
      if (isSimpleAtc || !hasScents) return true;
      return selectedTotal() === state.selectedQty;
    }

    function fillEachLabels() {
      // Per-unit “each” prices intentionally hidden
    }

    function updateProgress() {
      if (!hasScents || !els.progress) return;
      var total = selectedTotal();
      var target = state.selectedQty;
      var pct = target > 0 ? Math.min(100, Math.round((total / target) * 100)) : 0;
      var rem = remaining();
      var over = total > target;
      var complete = rem === 0 && !over && total > 0;

      var text;
      if (over) {
        text = (config.i18n.progressOver || '')
          .replace(/\[selected\]/g, String(total))
          .replace(/\[count\]/g, String(target));
      } else if (complete) {
        text = (config.i18n.progressComplete || '')
          .replace(/\[selected\]/g, String(total))
          .replace(/\[count\]/g, String(target));
      } else {
        text = (config.i18n.progressPartial || '')
          .replace(/\[selected\]/g, String(total))
          .replace(/\[count\]/g, String(target));
      }

      if (els.progressText) els.progressText.textContent = text;
      if (els.progressFill) els.progressFill.style.width = pct + '%';
      els.progress.classList.toggle('is-complete', complete);
      els.progress.classList.toggle('is-over', over);
    }

    function updateSummary() {
      if (!hasScents || !els.summary) return;
      var items = [];
      config.scents.forEach(function (s) {
        var qty = Number(state.scents[s.key]) || 0;
        if (qty > 0) items.push({ name: s.name, qty: qty });
      });

      if (!items.length) {
        els.summary.innerHTML =
          '<p class="jrb-summary__empty">' +
          escapeHtml(config.i18n.summaryEmpty || '') +
          '</p>';
        return;
      }

      var html = '<ul class="jrb-summary__list">';
      items.forEach(function (item) {
        html +=
          '<li><span>' +
          escapeHtml(item.name) +
          '</span><span>×' +
          item.qty +
          '</span></li>';
      });
      html += '</ul>';
      els.summary.innerHTML = html;
    }

    function updateScentControls() {
      if (!hasScents) return;
      var rem = remaining();
      els.scentRows.forEach(function (row) {
        var key = row.getAttribute('data-jrb-scent');
        var valueEl = row.querySelector('[data-jrb-scent-value]');
        var minus = row.querySelector('[data-jrb-scent-minus]');
        var plus = row.querySelector('[data-jrb-scent-plus]');
        var qty = Number(state.scents[key]) || 0;
        if (valueEl) valueEl.textContent = String(qty);
        if (minus) minus.disabled = qty <= 0;
        if (plus) plus.disabled = rem <= 0;
      });
    }

    function updateBuyAndAtc() {
      var bundle = currentBundle();
      var priceText =
        bundle && bundle.price != null
          ? money(bundle.price, config.moneyFormat)
          : '—';

      if (els.buyPrice) els.buyPrice.textContent = priceText;

      if (els.chooseLabel) {
        var base = config.i18n.chooseAll || 'Choose one scent for all';
        els.chooseLabel.textContent = base + ' ' + state.selectedQty;
      }

      if (!els.atc) return;
      var exact = isExact();
      // Single-SKU pages: enable ATC whenever we have a variant id.
      // Multi-pack: respect the per-option available flag.
      var available = isSimpleAtc
        ? !!(bundle && state.selectedVariantId)
        : !!(bundle && bundle.available && state.selectedVariantId);
      els.atc.disabled = !(exact && available) || state.submitting;

      var template = isSimpleAtc
        ? config.i18n.atcSimple || 'Add to cart • [price]'
        : config.i18n.atcTemplate || 'Add [label] • [price]';
      els.atc.textContent = template
        .replace(/\[label\]/g, bundle ? bundle.label : '')
        .replace(/\[price\]/g, priceText);

      if (els.error) {
        if (!state.selectedVariantId) {
          els.error.textContent = config.i18n.missingVariant || '';
        } else if (hasScents && selectedTotal() > 0 && selectedTotal() < state.selectedQty) {
          els.error.textContent = (config.i18n.needExact || '')
            .replace(/\[remaining\]/g, String(remaining()))
            .replace(/\[count\]/g, String(state.selectedQty));
        } else if (hasScents && selectedTotal() > state.selectedQty) {
          els.error.textContent = (config.i18n.progressOver || '')
            .replace(/\[selected\]/g, String(selectedTotal()))
            .replace(/\[count\]/g, String(state.selectedQty));
        } else if (!available && !isSimpleAtc) {
          els.error.textContent = config.i18n.unavailable || '';
        } else {
          els.error.textContent = '';
        }
      }
    }

    function render() {
      updateProgress();
      updateSummary();
      updateScentControls();
      updateBuyAndAtc();
    }

    function setBundle(qty, variantId) {
      state.selectedQty = Number(qty);
      state.selectedVariantId = variantId ? Number(variantId) : null;

      var total = selectedTotal();
      if (total > state.selectedQty) {
        var overflow = total - state.selectedQty;
        var keys = Object.keys(state.scents).reverse();
        for (var i = 0; i < keys.length && overflow > 0; i++) {
          var take = Math.min(state.scents[keys[i]], overflow);
          state.scents[keys[i]] -= take;
          overflow -= take;
        }
      }

      els.bundles.forEach(function (btn) {
        var selected = Number(btn.getAttribute('data-jrb-qty')) === state.selectedQty;
        btn.classList.toggle('is-selected', selected);
        var input = btn.querySelector('input[type="radio"]');
        if (input) input.checked = selected;
      });

      closeChooseMenu();
      render();
    }

    function setScentQty(key, next) {
      var others = 0;
      Object.keys(state.scents).forEach(function (k) {
        if (k !== key) others += Number(state.scents[k]) || 0;
      });
      var maxForThis = Math.max(0, state.selectedQty - others);
      state.scents[key] = Math.max(0, Math.min(maxForThis, Number(next) || 0));
      render();
    }

    function chooseAll(key) {
      config.scents.forEach(function (s) {
        state.scents[s.key] = s.key === key ? state.selectedQty : 0;
      });
      closeChooseMenu();
      render();
    }

    function openChooseMenu() {
      if (!els.chooseMenu || !els.chooseToggle) return;
      els.chooseMenu.hidden = false;
      els.chooseMenu.classList.add('is-open');
      els.chooseToggle.classList.add('is-open');
      els.chooseToggle.setAttribute('aria-expanded', 'true');
    }

    function closeChooseMenu() {
      if (!els.chooseMenu || !els.chooseToggle) return;
      els.chooseMenu.hidden = true;
      els.chooseMenu.classList.remove('is-open');
      els.chooseToggle.classList.remove('is-open');
      els.chooseToggle.setAttribute('aria-expanded', 'false');
    }

    function buildProperties() {
      var props = {};
      var bundle = currentBundle();
      if (!isSimpleAtc) {
        props[config.propertyKeys.bundleSize || 'Bundle Size'] = bundle.label;
        var parts = [];
        config.scents.forEach(function (s) {
          var qty = Number(state.scents[s.key]) || 0;
          if (qty > 0) {
            props[s.name] = String(qty);
            parts.push(s.name + ' ×' + qty);
          }
        });
        if (parts.length) {
          props[config.propertyKeys.scentMix || 'Scent Mix'] = parts.join(', ');
        }
      }
      props['Purchase Type'] = 'One-time purchase';
      return props;
    }

    function refreshCartDrawer() {
      return fetch('?sections=cart-drawer,cart-icon-bubble&timestamp=' + Date.now())
        .then(function (res) {
          return res.json();
        })
        .then(function (sections) {
          if (sections && sections['cart-drawer']) {
            var cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) {
              cartDrawer.classList.add('is-loading');
              cartDrawer.classList.remove('is-empty');

              var parser = new DOMParser();
              var newDoc = parser.parseFromString(sections['cart-drawer'], 'text/html');

              var cartItems = cartDrawer.querySelector(
                '.cart-items, [id*="cart-items"], .drawer__inner'
              );
              var newCartItems = newDoc.querySelector(
                '.cart-items, [id*="cart-items"], .drawer__inner'
              );

              if (cartItems && newCartItems) {
                cartItems.innerHTML = newCartItems.innerHTML;
              } else {
                var drawerContent = cartDrawer.querySelector(
                  '.drawer__content, .cart-drawer__content'
                );
                var newDrawerContent = newDoc.querySelector(
                  '.drawer__content, .cart-drawer__content'
                );
                if (drawerContent && newDrawerContent) {
                  drawerContent.innerHTML = newDrawerContent.innerHTML;
                }
              }

              cartDrawer.classList.remove('is-loading', 'is-empty');
              cartDrawer.classList.add('is-loaded', 'animate', 'active');
              cartDrawer.setAttribute('open', '');
              document.body.classList.add('overflow-hidden');

              if (typeof cartDrawer.open === 'function') {
                cartDrawer.open();
              }
            }
          }

          if (sections && sections['cart-icon-bubble']) {
            var parser2 = new DOMParser();
            var doc = parser2.parseFromString(sections['cart-icon-bubble'], 'text/html');
            var newBubble = doc.querySelector('.cart-count-bubble');
            var cartIconBubble = document.querySelector('#cart-icon-bubble');
            if (cartIconBubble && newBubble) {
              var existingBubble = cartIconBubble.querySelector('.cart-count-bubble');
              if (existingBubble) {
                existingBubble.innerHTML = newBubble.innerHTML;
              } else {
                cartIconBubble.appendChild(newBubble.cloneNode(true));
              }
            }
          }

          document.dispatchEvent(new CustomEvent('cart:updated'));
        });
    }

    function addToCart() {
      if (!isExact() || state.submitting) return;
      var bundle = currentBundle();
      if (!bundle || !bundle.available || !state.selectedVariantId) return;

      state.submitting = true;
      if (els.atc) {
        els.atc.classList.add('is-loading');
        els.atc.disabled = true;
        els.atc.setAttribute('aria-busy', 'true');
      }

      var rootPath =
        window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/';

      fetch(rootPath + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: Number(state.selectedVariantId),
              quantity: 1,
              properties: buildProperties()
            }
          ]
        })
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (err) {
              throw err;
            });
          }
          return response.json();
        })
        .then(function () {
          var cartType = document.body.getAttribute('data-cart-type') || 'drawer';
          if (cartType === 'page') {
            window.location.href = config.cartUrl || '/cart';
            return null;
          }
          var giftPromise = window.__addCheckpointGifts
            ? window.__addCheckpointGifts()
            : Promise.resolve();
          return giftPromise.then(function () {
            return refreshCartDrawer();
          });
        })
        .catch(function (err) {
          var msg =
            (err && (err.description || err.message)) || config.i18n.addError || '';
          if (els.error) els.error.textContent = msg;
        })
        .finally(function () {
          state.submitting = false;
          if (els.atc) {
            els.atc.classList.remove('is-loading');
            els.atc.removeAttribute('aria-busy');
          }
          render();
        });
    }

    els.bundles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.classList.contains('is-unavailable')) return;
        setBundle(btn.getAttribute('data-jrb-qty'), btn.getAttribute('data-jrb-variant-id'));
      });
    });

    els.scentRows.forEach(function (row) {
      var key = row.getAttribute('data-jrb-scent');
      var minus = row.querySelector('[data-jrb-scent-minus]');
      var plus = row.querySelector('[data-jrb-scent-plus]');
      if (minus) {
        minus.addEventListener('click', function () {
          setScentQty(key, (Number(state.scents[key]) || 0) - 1);
        });
      }
      if (plus) {
        plus.addEventListener('click', function () {
          setScentQty(key, (Number(state.scents[key]) || 0) + 1);
        });
      }
    });

    if (els.chooseToggle) {
      els.chooseToggle.addEventListener('click', function () {
        if (els.chooseMenu && els.chooseMenu.classList.contains('is-open')) {
          closeChooseMenu();
        } else {
          openChooseMenu();
        }
      });
    }

    els.chooseOptions.forEach(function (btn) {
      btn.addEventListener('click', function () {
        chooseAll(btn.getAttribute('data-jrb-choose-all'));
      });
    });

    if (els.chooseMenu) {
      els.chooseMenu.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-jrb-choose-all]');
        if (!btn || !els.chooseMenu.contains(btn)) return;
        chooseAll(btn.getAttribute('data-jrb-choose-all'));
      });
    }

    document.addEventListener('click', function (e) {
      if (!els.chooseToggle || !els.chooseMenu) return;
      if (!root.contains(e.target)) return;
      if (
        !els.chooseToggle.contains(e.target) &&
        !els.chooseMenu.contains(e.target)
      ) {
        closeChooseMenu();
      }
    });

    if (els.atc) {
      els.atc.addEventListener('click', function (e) {
        e.preventDefault();
        addToCart();
      });
    }

    fillEachLabels();

    var first = null;
    if (isSimpleAtc) {
      first = config.bundles[0];
    } else {
      for (var i = 0; i < config.bundles.length; i++) {
        if (config.bundles[i].variantId && config.bundles[i].available) {
          var preferQty = isBundleMode ? 3 : 8;
          if (Number(config.bundles[i].qty) === preferQty) {
            first = config.bundles[i];
            break;
          }
          if (!first) first = config.bundles[i];
        }
      }
      if (!first) first = config.bundles[0];
    }
    setBundle(first.qty, first.variantId);
  }

  function boot() {
    document.querySelectorAll('[data-jrb-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // In case script loads after DOM is ready and roots already exist
  setTimeout(boot, 0);

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    var root = event.target.querySelector('[data-jrb-root]');
    if (root) {
      root.removeAttribute('data-jrb-ready');
      initRoot(root);
    }
  });
})();
